<template>
  <div class="min-h-screen flex flex-col">
    <BlackFridayBanner />

    <div class="flex-1 flex items-center justify-center p-4">
      <div class="max-w-xl w-full">
        <BackButton @click="$emit('previous')" />

        <div class="bg-white rounded-2xl shadow-xl p-6">
          <QuizProgress :current-step="2" />

          <NameHeader />

          <div class="space-y-4">
            <NameField
              v-model="name"
              @submit="submitName"
            />

            <NameNote />

            <button
              @click="submitName"
              class="w-full py-4 px-6 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Warning Popup -->
    <NameWarningPopup
      :show="showWarning"
      @close="showWarning = false"
    />

    <LegalFooter />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import BlackFridayBanner from '../../../BlackFridayBanner.vue'
import LegalFooter from '../../../LegalFooter.vue'
import BackButton from '../../../common/BackButton.vue'
import QuizProgress from '../../QuizProgress.vue'
import NameHeader from './components/NameHeader.vue'
import NameField from './components/NameField.vue'
import NameNote from './components/NameNote.vue'
import NameWarningPopup from './components/NameWarningPopup.vue'
import { useNameValidation } from './composables/useNameValidation'

defineProps<{
  gender: 'male' | 'female'
}>()

const emit = defineEmits<{
  (e: 'name-submitted', name: string): void
  (e: 'previous'): void
}>()

const name = ref('')
const showWarning = ref(false)
const { hasMultipleNames } = useNameValidation(name)

const submitName = () => {
  const trimmedName = name.value.trim()

  if (!trimmedName) {
    return
  }

  if (!hasMultipleNames.value) {
    showWarning.value = true
    return
  }

  // Store name in localStorage for checkout tracking
  localStorage.setItem('quiz_name', trimmedName)
  emit('name-submitted', trimmedName)
}
</script>